{
  "ar-AR": {
    "koji": "كوجي",
    "kojiFoods": "الأطعمة كوجي",
    "foodsMakeWithKoji": "الأطعمة اليابانية والتوابل والمشروبات المصنوعة من الكوجي",
    "kojiColors": "ألوان كوجي",
    "white": "أبيض (أخضر)",
    "yellow": "أصفر",
    "black": "أسود",
    "name": "اسم",
    "description": "وصف",
    "soySauce": "شويو",
    "soySauceDescription": "بهار سائل مصنوع من فول الصويا وكوجي والقمح.",
    "miso": "ميسو",
    "misoDescription": "توابل يابانية تقليدية.",
    "amazake": "أمازاكي",
    "amazakeDescription": "مشروب أرز حلو.",
    "sake": "من أجل",
    "sakeDescription": "نبيذ الأرز.",
    "mirin": "ميرين",
    "mirinDescription": "نبيذ أرز حلو.",
    "riceWineVinegar": "خل نبيذ الأرز",
    "riceWineVinegarDescription": "خل مصنوع من نبيذ الأرز.",
    "cancel": "يلغي",
    "confirm": "يتأكد"
  },
  "en-US": {
    "koji": "Koji",
    "kojiFoods": "Koji foods",
    "foodsMakeWithKoji": "Japanese foods, condiments, and beverages made with koji",
    "kojiColors": "Colors of koji",
    "white": "white (green)",
    "yellow": "yellow",
    "black": "black",
    "name": "Name",
    "description": "Description",
    "soySauce": "Shoyu",
    "soySauceDescription": "A liquid condiment made from soybeans, koji, and wheat.",
    "miso": "Miso",
    "misoDescription": "A traditional Japanese seasoning.",
    "amazake": "Amazake",
    "amazakeDescription": "A sweet rice drink.",
    "sake": "Sake",
    "sakeDescription": "Rice wine.",
    "mirin": "Mirin",
    "mirinDescription": "Sweet rice wine.",
    "riceWineVinegar": "Rice wine vinegar",
    "riceWineVinegarDescription": "Vinegar made from rice wine.",
    "cancel": "Cancel",
    "confirm": "Confirm"
  },
  "he-IL":{
    "koji": "קוג'י",
    "kojiFoods": "מזונות קוג'י",
    "foodsMakeWithKoji": "אוכל יפני, תבלינים ומשקאות עשויים עם קוג'י",
    "kojiColors": "צבעים של קוג'י",
    "white": "לבן (ירוק)",
    "yellow": "צהוב",
    "black": "שָׁחוֹר",
    "name": "שֵׁם",
    "description": "תיאור",
    "soySauce": "שויו",
    "soySauceDescription": "תבלין נוזלי העשוי מפולי סויה, קוג'י וחיטה.",
    "miso": "מיסו",
    "misoDescription": "תיבול יפני מסורתי.",
    "amazake": "אמזאקה",
    "amazakeDescription": "משקה אורז מתוק.",
    "sake": "סאקה",
    "sakeDescription": "יין אורז.",
    "mirin": "מירין",
    "mirinDescription": "יין אורז מתוק.",
    "riceWineVinegar": "חומץ יין אורז",
    "riceWineVinegarDescription": "חומץ עשוי מיין אורז.",
    "cancel": "לְבַטֵל",
    "confirm": "לְאַשֵׁר"
  }
  ,
  "ja-JP": {
    "koji": "麹",
    "kojiFoods": "麹食品",
    "foodsMakeWithKoji": "麹を使った和食・調味料・飲料",
    "kojiColors": "麹の色",
    "white": "白（緑",
    "yellow": "黄色",
    "black": "黒",
    "name": "名前",
    "description": "説明",
    "soySauce": "醤油",
    "soySauceDescription": "大豆、麹、小麦から作られた液体調味料です。",
    "miso": "味噌",
    "misoDescription": "日本の伝統的な調味料。",
    "amazake": "甘酒",
    "amazakeDescription": "甘いお米のドリンク。",
    "sake": "酒",
    "sakeDescription": "お酒。",
    "mirin": "みりん",
    "mirinDescription": "味醂。",
    "riceWineVinegar": "米酢",
    "riceWineVinegarDescription": "米酒から作られたお酢。",
    "cancel": "キャンセル",
    "confirm": "確認"
  },
  "ko-KR": {
    "koji": "코지",
    "kojiFoods": "누룩 식품",
    "foodsMakeWithKoji": "누룩으로 만든 일본 음식, 조미료 및 음료",
    "kojiColors": "누룩의 색",
    "white": "흰색(녹색)",
    "yellow": "노란색",
    "black": "검은색",
    "name": "이름",
    "description": "설명",
    "soySauce": "쇼유",
    "soySauceDescription": "콩, 누룩, 밀로 만든 액체 조미료.",
    "miso": "된장",
    "misoDescription": "일본의 전통 조미료.",
    "amazake": "감주",
    "amazakeDescription": "달콤한 쌀 음료.",
    "sake": "동기",
    "sakeDescription": "막걸리.",
    "mirin": "미린",
    "mirinDescription": "달콤한 막걸리.",
    "riceWineVinegar": "막걸리식초",
    "riceWineVinegarDescription": "막걸리로 만든 식초.",
    "cancel": "취소",
    "confirm": "확인하다"
  },
  "zh-CN": {
    "koji": "小司",
    "kojiFoods": "酒曲食品",
    "foodsMakeWithKoji": "用曲制成的日本食品、调味品和饮料",
    "kojiColors": "酒曲的颜色",
    "white": "白（绿）",
    "yellow": "黄色的",
    "black": "黑色的",
    "name": "姓名",
    "description": "描述",
    "soySauce": "酱油",
    "soySauceDescription": "一种由大豆、曲和小麦制成的液体调味品。",
    "miso": "味噌",
    "misoDescription": "日本传统调味料",
    "amazake": "甘酒",
    "amazakeDescription": "一种甜米饮料。",
    "sake": "清酒",
    "sakeDescription": "米酒。",
    "mirin": "料酒",
    "mirinDescription": "甜米酒。",
    "riceWineVinegar": "米酒醋",
    "riceWineVinegarDescription": "用米酒制成的醋。",
    "cancel": "取消",
    "confirm": "确认"
  },
  "zh-TW": {
    "koji": "小司",
    "kojiFoods": "酒麯食品",
    "foodsMakeWithKoji": "用曲製成的日本食品、調味品和飲料",
    "kojiColors": "酒麯的顏色",
    "white": "白（綠）",
    "yellow": "黃色的",
    "black": "黑色的",
    "name": "姓名",
    "description": "描述",
    "soySauce": "醬油",
    "soySauceDescription": "一種由大豆、曲和小麥製成的液體調味品。",
    "miso": "味噌",
    "misoDescription": "日本傳統調味料。",
    "amazake": "甘酒",
    "amazakeDescription": "一種甜米飲料。",
    "sake": "清酒",
    "sakeDescription": "米酒。",
    "mirin": "料酒",
    "mirinDescription": "甜米酒。",
    "riceWineVinegar": "米酒醋",
    "riceWineVinegarDescription": "用米酒製成的醋。",
    "cancel": "取消",
    "confirm": "確認"
  }
}